import { __assign } from "tslib";
import { createLinesApiTestKit } from './lines/testkit';
import { createIvrsApiTestKit } from './ivrs/testkit';
import { createHttpTestKit } from '../http/test-kit';
import { createFakeGetResponder, createFakePostResponder, createFakePutResponder } from '../test-utils';
import { createCallcenterApi, buildStatsFilterFromDto } from './index';
import { createQueuesTestKit } from './queues/testkit';
import { createCallsApiTestKit } from './calls/testkit';
import { createCallCenterInsightsApiTestkit } from './insights/testkit';
export var createCallcenterApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createCallcenterApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenUpdateAssignedQueuesPriorities: function (dto) { return createFakePutResponder(fakeHttp, "/callcenter/agents/" + dto.userId + "/queues/priorities")(dto); },
        whenGetCurrentAgent: function () { return createFakeGetResponder(fakeHttp, '/callcenter/agents/me'); },
        whenSetCallCenterActivity: createFakePostResponder(fakeHttp, '/callcenter/agents/activity'),
        whenSetAgentStatus: function (dto) { return createFakePostResponder(fakeHttp, "/callcenter/agents/activity/admin")(dto); },
        whenStartShift: createFakePostResponder(fakeHttp, '/callcenter/agents/start-shift'),
        whenEndShift: createFakePostResponder(fakeHttp, '/callcenter/agents/end-shift'),
        whenGetAgent: function (id) { return createFakeGetResponder(fakeHttp, "/callcenter/agents/" + id); },
        whenSyncAgent: function (userId) { return createFakePostResponder(fakeHttp, '/callcenter/agents/sync')({ userId: userId }); },
        whenGetDashboardStats: function (dto) { return createFakePostResponder(fakeHttp, "/callcenter/stats")(dto); },
        whenGetStats: function (dto) { return createFakeGetResponder(fakeHttp, "/callcenter/stats" + buildStatsFilterFromDto(dto)); },
        whenGetQueuesStats: function () { return createFakeGetResponder(fakeHttp, '/callcenter/stats/queues'); },
        whenSearchAgents: function (dto) {
            return createFakePostResponder(fakeHttp, '/callcenter/agents/search')(dto);
        },
        whenAddAgent: function (dto) { return createFakePostResponder(fakeHttp, "/agents/" + dto.id + "/callcenter")({}); },
        whenGetWorkerToken: function () { return createFakeGetResponder(fakeHttp, '/callcenter/agents/worker-token'); },
        whenVerifyCallCenter: function (dto) {
            return createFakePostResponder(fakeHttp, 'https://app.wixanswers.com/adminApi/cc-verification')(dto);
        },
        whenEnableAgentExtendedTimeout: function (dto) { return createFakePostResponder(fakeHttp, "/callcenter/agents/" + dto.id + "/extendCallbackReservationTimeout/enable")({}); },
        whenDisableAgentExtendedTimeout: function (dto) { return createFakePostResponder(fakeHttp, "/callcenter/agents/" + dto.id + "/extendCallbackReservationTimeout/disable")({}); },
        whenUpdateAgentsQueueAssignments: function (dto) { return createFakePostResponder(fakeHttp, "/callcenter/agents/queues")(dto); },
        queues: createQueuesTestKit('/callcenter'),
        calls: createCallsApiTestKit('/callcenter'),
        ivrs: createIvrsApiTestKit('/callcenter'),
        lines: createLinesApiTestKit('/callcenter'),
        insights: createCallCenterInsightsApiTestkit('/callcenter')
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map